import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TeamContext } from "../Contexts/TeamContext";
import Alert from "../components/Alert";

const TeamForm = () => {
  const navigate = useNavigate();
  const { createTeamMember } = useContext(TeamContext);
  const [alert, setAlert] = useState({ status: "", message: "" });

  const [name, setName] = useState("");
  const [position, setPosition] = useState("");
  const [image, setImage] = useState(null);

  const handleCancel = () => {
    navigate("/admin/dashboard");
  };

  const handleImageChange = (event) => {
    setImage(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("name", name);
    formData.append("position", position);
    formData.append("image", image);

    try {
      await createTeamMember(formData); // Wait for the team member to be created
      setAlert({
        status: "success",
        message: "Team Member created successfully!",
      });
      setTimeout(() => {
        navigate("/admin/view/members"); // Navigate after updating the state
      }, 2000);
    } catch (error) {
      const errorMessage =
        error.message || "Failed to create team member.";
      setAlert({ status: "error", message: errorMessage });
    }
  };

  return (
    <div className="bg-gray-100 py-10">
      {alert.message && (
        <Alert
          status={alert.status}
          message={alert.message}
          onClose={() => setAlert({ status: "", message: "" })}
        />
      )}
      <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">
          Team Member Form
        </h1>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="name"
              className="block text-gray-700 font-medium mb-2"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="position"
              className="block text-gray-700 font-medium mb-2"
            >
              Position
            </label>
            <input
              type="text"
              id="position"
              name="position"
              value={position}
              onChange={(e) => setPosition(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="image"
              className="block text-gray-700 font-medium mb-2"
            >
              Image
            </label>
            <input
              type="file"
              id="image"
              name="image"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
              onChange={handleImageChange}
              required
            />
          </div>

          <div className="flex space-x-4">
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600"
            >
              Submit
            </button>
            <button
              type="button"
              onClick={handleCancel}
              className="px-4 py-2 bg-gray-600 text-white rounded-lg shadow hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-600"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TeamForm;
